"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const rebass_1 = require("rebass");
const styled_components_1 = require("styled-components");
const footer_1 = require("../components/footer");
const header_1 = require("../components/header");
const quiz_1 = require("../helpers/quiz");
exports.theme = {
    colors: {
        darkPurple: '#352734',
        darkWhite: '#F5F5F5',
        lightPurple: '#674A64',
        purple: '#5A4258',
        red: '#FF565C',
        yellow: '#EDB732',
    },
    fonts: {
        sans: 'Lato, sans-serif',
    }
};
exports.PAGE_WIDTH = 900;
styled_components_1.injectGlobal `
  a { text-decoration: none }
  button:hover { cursor: pointer }
  html, body { margin: 0 }

  .sans-2 { font-family: 'Open Sans', sans-serif }
  .serif { font-family: 'Libre Baskerville', serif }

  .red { color: ${exports.theme.colors.red} }
  .yellow { color: ${exports.theme.colors.yellow} }
`;
exports.AuthContext = React.createContext({
    canViewGuide: null,
    initAuth: null,
});
class Layout extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            canViewGuide: null,
        };
        this.initAuth = () => {
            this.setState({
                ...this.state,
                canViewGuide: quiz_1.didFinishQuiz(),
            });
        };
    }
    componentDidMount() {
        this.initAuth();
    }
    render() {
        const authContextValue = {
            canViewGuide: this.state.canViewGuide,
            initAuth: this.initAuth,
        };
        return (React.createElement(rebass_1.Provider, { theme: exports.theme },
            React.createElement(exports.AuthContext.Provider, { value: authContextValue },
                React.createElement(rebass_1.Flex, { flexDirection: 'column', justifyContent: 'space-between', style: { minHeight: '100vh' } },
                    !this.props.hideHeader && React.createElement(header_1.default, null),
                    React.createElement(rebass_1.Flex, { flex: '1', flexDirection: 'column' }, this.props.children),
                    !this.props.hideFooter && React.createElement(footer_1.default, null)))));
    }
}
exports.default = Layout;



// WEBPACK FOOTER //
// ./src/components/layout.tsx